import { Sheet } from './sheet';
import { Area, CellPosition } from './area';
import { ColFilters, FilterSettings } from './filters';

export enum DateAcceptedFormatType {
  'MonthFirst' = 'Month First', // MM/DD
  'DayFirst' = 'Day First', // DD/MM
}

export enum SelectionCell {
  Root = 'Root',
  Row = 'Row',
  Column = 'Column',
  Cell = 'Cell',
}

export enum SelectionOperationType {
  SelectionMove = 'SelectionMove', //Move Selection
  Extend = 'Extend',
  ColMove = 'ColMove',
  RowMove = 'RowMove',
}

export interface ViewportSet {
  indexes: number[];
  sizes: number[];
  sum: number;
}

export interface Viewport {
  frozenIndexes: number[];
  frozenSizes: number[];
  frozenSum: number;

  nonFrozenIndexes: number[];
  nonFrozenSizes: number[];
  nonFrozenSum: number;
  
  alternateEntityGroupBarSize: number; // In case of rowViewport it is the size of rowGroupBarWidth | In case of col it is colGroupBarHeight
}

export interface SheetSelection {
  area: Area;
  cell: SelectionCell;
}

export interface FilterIndexesMap {
  [key: number]: number;
}

export interface FilterResults {
  startRow: number;
  hasFilter: boolean;
  rowsIndexes: number[];
  filterIndexesMap: FilterIndexesMap;
  lastRow: number;
}

export type TemporarySelection =
  | {
      op: SelectionOperationType.Extend;
      area: Area;
    }
  | {
      op: SelectionOperationType.SelectionMove;
      initialPosition: CellPosition;
      area: Area;
    }
  | {
      op: SelectionOperationType.ColMove | SelectionOperationType.RowMove;
      initialPositionIndex: number;
      area: Area;
    };

export interface SheetView {
  readonly activeCellArea: Area;
  readonly activeCell: CellPosition;
  readonly selections: SheetSelection[]; // Last Selection will be active by default
  // readonly viewport: Viewport;
  readonly isLocalFilter?: boolean; // Only for tab
  readonly localFilters?: ColFilters;
  readonly localFilterSettings?: FilterSettings;

  readonly rowViewport: Viewport;
  readonly colViewport: Viewport;

  // selecting?: boolean;
  readonly temporarySelection?: TemporarySelection;

  readonly filterResults: FilterResults;
  // viewportSize: Size,
  // rowHeaderWidth: number;
}

export type SheetViewportView = Pick<
  SheetView,
  'colViewport' | 'rowViewport' | 'filterResults'
>;

export interface Sheets {
  [key: string]: Sheet;
}

export type PartialSheet = Pick<Sheet, 'id'> & Partial<Sheet>;

export interface PartialSheets {
  [key: string]: PartialSheet;
}

export interface PartialSheetViews {
  [key: string]: Partial<SheetView>;
}

// export interface SheetChanges {
//   [sheetId: string]: Patch[]
// }

export interface SheetViews {
  [sheetId: string]: SheetView;
}

export interface StaleSheets {
  [sheetId: string]: boolean;
}

export type SelectedLineType = 'column' | 'row' | 'none';
// export interface SheetNames {
//   [key: string]: string;
// }
